/**
 * Business-dialect overrides. Sparse: a missing key falls back to en. Only the
 * leaves that name a matter or a legal supplier differ.
 */
export const emptyState = {
    steps: {
        matter: {
            noun: 'a project',
            title: 'Open a project',
            doneMany: 'Projects open',
            next: {
                titleOne: 'Open a project for {{client}}',
                bodyOne: 'Time and expenses are recorded against a project.',
                titleMany: 'Open a project',
            },
            action: 'Open a project',
            ask: {
                helpOne: 'Help me open a project for {{client}}',
                helpMany: 'Help me open my first project',
                what: 'What is a project in Bill?',
            },
        },
        activity: {
            next: {
                bodyMany: 'Log time against any of your projects.',
            },
        },
        expense: {
            ask: {
                billOn: "How do I bill a supplier's invoice to my client?",
            },
        },
    },
    pages: {
        activities: {
            intro: 'Record time against projects, then approve it for invoicing.',
        },
    },
    activities: {
        projectTitle: 'No activities recorded for this project',
    },
};
